import React, { memo } from "react";
import { Button as AntdButton } from "antd";
import { ButtonProps } from "antd/es/button";

const Button = ({ ...rest }: ButtonProps) => {
  return <AntdButton size="large" {...rest} />;
};

export default memo(Button);
